import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { WebSocketService } from '../../services/web-socket.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: { parentBreadcrumb?: string | null; childBreadcrumb?: string } | undefined;
  public title: string = '';

  // Default value
  formattedDate: string = this.formatDate(new Date());
  HomeUrl: string | null = localStorage.getItem('localRedirection')
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private socket: WebSocketService
  ) {
    // Handle routing changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let parent = route.parent?.snapshot.data['parentBreadcrumb'];
        let child = route.snapshot.data['childBreadcrumb'];
        this.breadcrumbs = { parentBreadcrumb: parent, childBreadcrumb: child };
      });
  }

  ngOnInit(): void {
    this.socket.getMessages().subscribe((msg: any) => {
      if (msg && msg.Last_Sync_Time) {
        this.formattedDate = this.formatDateFromApi(msg.Last_Sync_Time);
        console.log(this.formattedDate);
      }
    });
  }

  // Util to format date
  private formatDate(date: Date): string {
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).replace(',', '');
  }
  private formatDateFromApi(apiDateStr: string): string {
    const date = new Date(apiDateStr.replace(' ', 'T'));

    const parts = date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).replace(',', '').split(' ');

    const [day, month, year, time] = parts;
    return `${day} ${month} ${year} ${time}`;
  }

}
